import React, {useState, useEffect} from "react";
import {
  Container,
  Row,
  Col,
  Card,

  CardBody,
  Form,
  FormGroup,
  Input,
  Label,
  Button,
  CardHeader,
} from "reactstrap";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import man from "../assets/images/dashboard/user.png";
import app
//, {
  //googleProvider,
  //facebookProvider,
  //twitterProvider,
  //githubProvider,
//}
  from "../data/base";
import {
  mainReducer,
  store,
  SET_PERMISSIONS,
  SET_ROLES,
  UN_AUTH_PATH,
  RouteGuard,
  HasRole,
} from 'react-role-permission';
import {has} from "lodash";
import {UserActions} from "../store/user/user.action";
import {useDispatch} from "react-redux";
import {useAppNavigate} from "../utils/link.utils";

const Signin = (props) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const [value, setValue] = useState(localStorage.getItem("profileURL" || man));
  const [name, setName] = useState(
    localStorage.getItem("Name") || "User"
  );
  const [isuser, setisuser] = useState(localStorage.getItem("isUser") || true);

  const dispatch = useDispatch();
  const navigate = useAppNavigate();

  useEffect(() => {
    localStorage.setItem("profileURL", value);
    localStorage.setItem("Name", name);
    localStorage.setItem("isUser", isuser);
    // eslint-disable-next-line
  }, [value, name, isuser]);

  const loginAuth = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {

      const result = await app.auth.signInWithEmailAndPassword(username, password);
      dispatch(UserActions.setUser(true))
      if (result) {
        setValue(man);
        setName(username);

        setisuser("true");
        setTimeout(function () {
          if (HasRole('admin') || HasRole('group_admin')) {
            navigate('/dashboard/default');
          } else {
            navigate('/sessions');
          }
        }, 500);

      } else {
        setLoading(false);
        setTimeout(() => {
          toast.error(
            "Qualcosa è andato storto..."
          );
        }, 200);

      }

    } catch (error) {
      console.log(error);
      setLoading(false);
      setTimeout(() => {
        toast.error(
          "Oppss.. The password is invalid or the user does not have a password."
        );
      }, 200);
    }
  };

  return (
    <div className="page-wrapper">
      <Container fluid={true} className="p-0">
        {/*  <!-- login page start--> */}
        <div className="authentication-main m-0 only-login">
          <Row>
            <Col xs="12">
              <div className="auth-innerright">
                <div className="authentication-box">
                  <Card className="h-100-d-center" style={{width: "60%", margin: "auto"}}>
                    <CardHeader className="b-l-primary border-3 card-header">

                      <h4>Streaming Project</h4>
                      <ul className="creative-dots">
                        <li className="bg-primary big-dot"></li>
                        <li className="bg-secondary semi-big-dot"></li>
                        <li className="bg-warning medium-dot"></li>
                        <li className="bg-info semi-medium-dot"></li>
                        <li className="bg-secondary semi-small-dot"></li>
                        <li className="bg-primary small-dot"></li>
                      </ul>
                    </CardHeader>
                    <CardBody className="h-100-d-center">
                      <div className="text-center b-light">
                        {/* <div> */}
                        <Form
                          onSubmit={loginAuth}
                          className="theme-form"
                          style={{width: "80%", margin: "auto"}}
                        >

                          <h6>Inserire username e password</h6>
                          <FormGroup>
                            <Label className="col-form-label pt-0">
                              Username
                            </Label>
                            <Input
                              className="form-control"
                              type="text"
                              name="email"
                              value={username}
                              onChange={(e) => setUsername(e.target.value)}
                              placeholder="username"
                            />
                          </FormGroup>
                          <FormGroup>
                            <Label className="col-form-label">Password</Label>
                            <Input
                              className="form-control"
                              type="password"
                              name="password"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              placeholder="password"
                            />
                          </FormGroup>
                          <div className="checkbox p-0">
                            <Input id="checkbox1" type="checkbox"/>
                            <Label for="checkbox1">Ricorda username</Label>
                          </div>
                          <FormGroup className="form-row mt-3 mb-0">
                            <Button
                              type={'submit'}
                              disabled={loading}
                              color="primary btn-block"
                            >
                              {loading ? 'Autenticando...' : 'Entra'}
                            </Button>

                          </FormGroup>
                        </Form>
                      </div>
                    </CardBody>
                  </Card>

                </div>
              </div>
            </Col>
          </Row>
        </div>
        <ToastContainer/>
        {/* <!-- login page end--> */}
      </Container>
    </div>
  );
};

export default Signin;
